import './src/html.scss';
import 'prismjs/themes/prism.css';
